import { itrInitialState, itrAction } from './initialState';
import { initApp, signIn } from '../reducers';
import { auth } from 'features/Auth/reducers';
import { commonReducers } from 'features/Common/reducers';

export const combineReducers = (
  state: itrInitialState,
  action: itrAction,
): any => {
  const { type } = action;

  const reducerSet = {
    ...initApp(state, action),
    ...signIn(state, action),
    ...auth(state, action),
    ...commonReducers(state, action),
  };

  return reducerSet[type](action);
};
